import { Button, Placeholder, Spinner } from '@telegram-apps/telegram-ui';

export function LoadingState() {
  return (
    <Placeholder header="Загрузка" description="Получаем данные витрины">
      <Spinner size="m" />
    </Placeholder>
  );
}

export function ErrorState({
  error,
  onRetry,
}: {
  error: Error;
  onRetry?: () => void;
}) {
  return (
    <Placeholder
      header="Не удалось загрузить данные"
      description={error.message}
      action={
        onRetry ? (
          <Button mode="filled" size="m" onClick={onRetry}>
            Повторить
          </Button>
        ) : undefined
      }
    >
      <div style={{ fontSize: 10, opacity: 0.4, marginTop: 16, textAlign: 'center' }}>
        build: {__BUILD_TS__}
      </div>
    </Placeholder>
  );
}
